module.exports = "/assets/0494eafb62557b6cc51c4528cf72b0e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/EB.png
// module id = 1330
// module chunks = 0